import { render } from "./TabsParentSite.vue?vue&type=template&id=267ed64e&ts=true"
import script from "./TabsParentSite.ts?vue&type=script&lang=ts"
export * from "./TabsParentSite.ts?vue&type=script&lang=ts"

import "./TabsParentSite.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__